import { render, staticRenderFns } from "./DataTableContainers.vue?vue&type=template&id=2cedc7aa"
import script from "./DataTableContainers.vue?vue&type=script&lang=js"
export * from "./DataTableContainers.vue?vue&type=script&lang=js"
import style0 from "./DataTableContainers.vue?vue&type=style&index=0&id=2cedc7aa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports